define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi/action/Controller"
], function(declare,lang,when,Controller) {

	return declare(Controller, {
		/** @property {Widget} targetPage - the page we navigate from */
		fromPage: null,

		process: function() {
			// summary: go to previous page after disabling actions and timeout
			if (this.widget.getPrevPage()) {
				this.setProgress();
				this.disableActionView(true);
				setTimeout(lang.hitch(this, this._processContinue), 1);
				this.widget.errorForm(""); // clear error msg
			} else {
				this.postProcess();
			}
		},

		_processContinue: function() {
			// summary: validate and proceed to next page
			when(this.widget.prevPage(this.fromPage), lang.hitch(this, this.postProcess, true, false));
		}
	});
});